import { themeBreakpoints } from '../foundations/breakpoints';
import { useBreakpoint } from './useBreakpoint';
/**
 * Referenced from https://stackoverflow.com/a/49725198
 */

var sortInitiatedValues = values => {
  var sortedValues = {};
  Object.keys(themeBreakpoints).forEach(breakpoint => {
    sortedValues[breakpoint] = values[breakpoint];
  });
  return sortedValues;
};
/**
 * Sorts the values according to themeBreakpoints order and sets all keys' value with the matches smallest defined value.
 * for example: provided object values: { l: 'large', s: 'small' }, the return value is: { xs: 'small', s: 'small', m: 'small', l: 'large', xl: 'large' }.
 */


export var sortBreakpoints = values => {
  var initiatedSortedBreakpoints = sortInitiatedValues(values);
  var sortedValues = {};
  var smallestDefinedKey = Object.keys(initiatedSortedBreakpoints).filter(k => initiatedSortedBreakpoints[k] !== undefined)[0];
  Object.keys(initiatedSortedBreakpoints).forEach(breakpoint => {
    sortedValues[breakpoint] = values[breakpoint] || undefined;

    if (initiatedSortedBreakpoints[breakpoint] !== undefined) {
      sortedValues[breakpoint] = initiatedSortedBreakpoints[breakpoint];
      smallestDefinedKey = breakpoint; // Update the smallestDefinedKey
    } else {
      sortedValues[breakpoint] = initiatedSortedBreakpoints[smallestDefinedKey];
    }
  });
  return sortedValues;
};
/**
 * React hook for getting the value for the current breakpoint from the
 * provided responsive values object.
 *
 * @param values
 * @example
 * const width = useBreakpointValue({ xs: '150px', s: '250px' })
 */

export function useBreakpointValue(values, defaultBreakpoint) {
  var {
    breakpoint
  } = useBreakpoint({
    defaultBreakpoint,
    debounce: 0
  });
  var sortedBreakpointsValues = sortBreakpoints(values);
  return sortedBreakpointsValues[breakpoint];
}
//# sourceMappingURL=useBreakpointValue.js.map